<template>
    <div class="radar">
        <div class="radar-star star-location-1"></div>
        <div class="radar-star star-location-2"></div>
        <div class="radar-star star-location-3"></div>
        <div class="radar-star star-location-4"></div>
        <div class="radar-star star-location-5"></div>
        <div class="radar-star star-location-6"></div>
        <div class="radar-star star-location-7"></div>
        <div class="radar-star star-location-8"></div>
        <div class="radar-star star-location-9"></div>
        <div class="radar-star star-location-10"></div>
    </div>
</template>

<script>

    export default {
        name: 'MonitorLeftRadar',
        data() {
            return {
                nowDate: "",
            }
        },
        computed: {

        },
        mounted() {
        },
        components: {

        },
        props: {

        },
        beforeDestroy() {
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/monitor/partials/MonitorLeftRadar.vue